import { useEffect, useState } from 'react'

const loadImageSize = (url) =>
  new Promise((resolve) => {
    if (!url) {
      resolve(null)
      return
    }
    const image = new Image()
    image.onload = () => resolve({ width: image.naturalWidth, height: image.naturalHeight })
    image.onerror = () => resolve(null)
    image.src = url
  })

/**
 * Equal-width cells: shared CSS aspect-ratio from the smaller natural height
 * of the two images (at equal column width). Returns e.g. "1 / 1.25" or null.
 */
export default function usePairedImageAspect(leftUrl, rightUrl) {
  const [aspectRatio, setAspectRatio] = useState(null)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      const [left, right] = await Promise.all([loadImageSize(leftUrl), loadImageSize(rightUrl)])
      if (cancelled) return
      const heightRatios = []
      if (left?.width > 0) heightRatios.push(left.height / left.width)
      if (right?.width > 0) heightRatios.push(right.height / right.width)
      if (!heightRatios.length) {
        setAspectRatio(null)
        return
      }
      setAspectRatio(`1 / ${Math.min(...heightRatios)}`)
    })()
    return () => {
      cancelled = true
    }
  }, [leftUrl, rightUrl])

  return aspectRatio
}
